<template>
    <!-- Tab panes -->
    <div v-if="validation_requests">
        <export-modal v-if="SAPExport.showModal"
                      @confirm="sendToSAP"
                      @cancel="SAPExport.showModal = false"></export-modal>
        <div class="tab-pane slide-left active" id="slide1">
            <div class="row column-seperation" style="margin-bottom: 20px;">
                <div class="col-md-4 pull-right" style="text-align: center;">
                    <template v-if="!customerValidated && !customerStoredInErp && !isUpdatingSAP && !hasContractInAgencyDisabledForTup">
                        <button @click="SAPExport.showModal = true"
                            v-if="customerHasMainRepresentative"
                            class="btn btn-info btn-lg btn-rounded btn-animated from-left fa fa-cloud"
                            type="button"
                        >
                            <span>Transformer en client SAP</span>
                        </button>

                        <button v-else 
                            class="btn btn-info btn-lg btn-rounded" 
                            type="button" 
                            disabled 
                            style="background-color: white; border-color: #788098;"
                        >
                            <span>Transformer en client SAP</span>
                        </button>
                    </template>
                </div>

                <div class="col-md-8">
                    <balance></balance>
                </div>
            </div>

            <div class="row column-seperation">
                <div class="col-md-4">
                    <edit-general v-if="editing.general"
                                  @cancel-edit="handleEditionCancel"
                                  @finish-edit="handleCustomerEdition($event)"
                                  :schema="customerForm.schema"
                                  :model="customerForm.model"
                                  :triggers="customerForm.triggers">
                    </edit-general>
                    <general v-else
                             :customer="profile"
                             :brands="brands.active"
                             :sap-organizations="sap_organizations"
                             @edit="editing.general = true">
                    </general>
                </div>

                <div class="col-md-4"
                     @keyup.esc="editing.address = false; creating.address = false">
                    <addresses v-if="!editing.address && !creating.address"
                               :addresses="addresses"
                               :main="mainAddress"
                               :billing="billingAddress"
                               @edit="prepareCustomerAddressEdition"
                               @create="prepareCustomerAddressCreation"
                               :edition="!customerStoredInErp"
                               :corresponding-address-editable="profile.corresponding_address_editable"
                               ></addresses>
                    <resource-form :model="addressForm.model"
                                   :schema="addressForm.schema"
                                   :triggers="addressForm.triggers"
                                   v-if="editing.address"
                                   @submit="handleAddressEdition">
                        <button slot="cancel"
                                class="btn btn-danger btn-sm"
                                @click.prevent="editing.address = false">
                            Annuler
                        </button>
                    </resource-form>
                    <resource-form :model="addressForm.model"
                                   :schema="addressForm.schema"
                                   :triggers="addressForm.triggers"
                                   v-if="creating.address"
                                   @submit="handleAddressCreation">
                        <button slot="cancel"
                                class="btn btn-danger btn-sm"
                                @click.prevent="creating.address = false">
                            Annuler
                        </button>
                    </resource-form>
                </div>

                <div class="col-md-4">
                    <social-certificate v-if="profile">
                    </social-certificate>
                </div>
            </div>

            <div class="row column-seperation">
                <div class="col-md-4">
                    <intermediary-business :model="intermediaryBusinessModel">
                    </intermediary-business>
                </div>

                <div class="col-md-4">
                    <comments :text="profile.comments"
                              :update="updateCustomerComments">
                    </comments>
                </div>

                <div class="col-md-4">
                    <validation-requests></validation-requests>
                </div>
            </div>
            <div class="column-seperation">
                <contracts v-if="contracts.length > 0" 
                    :contracts="contracts"
                    :orders="orders"></contracts>
            </div>

            <notificator :report="exportToErpReport"></notificator>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script type="text/babel">
    import General from './InformationsContent/General'
    import EditGeneral from './InformationsContent/Edit/General'
    import Addresses from './InformationsContent/Addresses'
    import SocialCertificate from './InformationsContent/SocialCertificate'
    import Comments from './InformationsContent/Comments'
    import Balance from './InformationsContent/Balance'
    import Contracts from './InformationsContent/Contracts'
    import Notificator from './InformationsContent/Notificator'
    import ExportModal from './InformationsContent/ExportModal'
    import ValidationRequests from './InformationsContent/ValidationRequests'
    import IntermediaryBusiness from './InformationsContent/IntermediaryBusiness'
    // import Newsfeed from './InformationsContent/Newsfeed'
    import { mapState, mapActions, mapGetters } from 'vuex'
    import ResourceForm from "components/Forms/ResourceForm"



    export default {

        name: "InformationsContentTab",

        components: {
            General,
            EditGeneral,
            Addresses,
            SocialCertificate,
            Comments,
            Balance,
            Contracts,
            ResourceForm,
            Notificator,
            ExportModal,
            ValidationRequests,
            IntermediaryBusiness,
            // Newsfeed
        },

        data () {
            return {

                editing: {
                    general: false,
                    address: false,
                },

                creating: {
                    address: false,
                },

                customerForm: {
                    schema: {},
                    model: {},
                    triggers: {},
                },

                addressForm: {
                    schema: {},
                    model: {},
                    triggers: {},
                },

                SAPExport: {
                    showModal: false,
                    customer: {}
                }

            }
        },

        created () {
            // get the customer edition form in cache
            this.editCustomer()
                .then(response => {
                    this.customerForm = _.assign({}, response.data.form)
                })
        },

        computed: {
            ...mapState('customer', [
                'profile',
                'mainAddress',
                'billingAddress',
                'representatives',
                'addresses',
                'orders',
                'contracts',
                'exportToErpReport',
                'validation_requests',
                'intermediaryBusiness',
                'sap_organizations',
                'isUpdatingSAP'
            ]),

            ...mapState("demands", ["users_infos"]),

            ...mapGetters('customer', {
                brands: 'filteredBrands'
            }),

            customerValidated () {
                return this.profile.validated
            },

            customerStoredInErp () {
                return this.profile.stored_in_erp
            },

            customerHasMainRepresentative () {
                return this.profile 
                    && this.profile.hasOwnProperty('main_representative')
                    && typeof this.profile.main_representative === 'object'
                    && this.profile.main_representative !== null
            },

            hasValidatedContract() {
              var total_contract = this.contracts != null && this.contracts.length ? this.contracts.length : 0;

              _.each(this.contracts, cnt => {
                if (cnt.validated == false)
                  total_contract -= 1
                })
              return (total_contract == 0 ? false : true)
            },

            intermediaryBusinessModel() {
                let ib = this.intermediaryBusiness

                return ib !== null && typeof ib === 'object' ? ib : {}
            },

            hasContractInAgencyDisabledForTup() {
                return undefined !== _.find(this.contracts, function (c) { return c.offer.distributed_product.agency.disabled_for_tup === true; })
            }
        },

        methods: {
            ...mapActions('customer', [
                'updateCustomerComments',
                'updateCustomer',
                'updateAddress',
                'addAddress',
                'sendToSAP'
            ]),

            ...mapActions("demands", ["getUserInfos"]),

            editCustomer () {
                return this.axios.get(`customers/${this.profile.id}/edit`)
            },

            editCustomerAddress (addressId) {
                const params = { with_selector: 1 }

                return this.axios.get(
                    `customers/${this.profile.id}/addresses/${addressId}/edit`, {
                        params
                    }
                )
            },

            editContractForwardingAddress (contractId, optionId) {
                return this.axios.get(
                    `contracts/${contractId}/options/${optionId}/addresses`
                )
            },

            prepareCustomerAddressEdition (addressId) {
                return this.editCustomerAddress(addressId)
                    .then(response => {
                        let { form } = response.data

                        this.addressForm = _.assign({}, form)
                        this.editing.address = true
                    })
            },

            handleAddressEdition ($event) {
                const model = $event.data
                model.validation_override = __REQUESTS_VALIDATION_OVERRIDE__
                return this.updateAddress(model)
                    .then(() => this.editing.address = false)
            },

            handleCustomerEdition ($event) {
                this.updateCustomer($event.data)
                    .then(() => this.editCustomer())
                    .then(response => {
                        this.customerForm = _.assign({}, response.data.form)
                        this.$store.commit('FORM_ERROR', {})
                    })
                    .then(() => this.editing.general = false)

            },

            handleEditionCancel () {
                this.editCustomer()
                    .then(response => {
                        this.customerForm = _.assign({}, response.data.form)
                        this.$store.commit('FORM_ERROR', {})
                    })
                this.editing.general = false
            },

            fetchCustomerAddressCreationForm (customer_usage) {
                const params = Object.assign({}, { customer_usage }, { with_selector: 1 })

                return this.axios.get(
                    `customers/${this.profile.id}/addresses/create`, {
                        params
                    })
            },

            prepareCustomerAddressCreation (customer_usage) {
                return this.fetchCustomerAddressCreationForm(customer_usage)
                    .then(response => {
                        let { form } = response.data

                        this.addressForm = _.assign({}, form)
                        this.creating.address = true
                    })
            },

            handleAddressCreation ($event) {
                const model = $event.data
                model.validation_override = __REQUESTS_VALIDATION_OVERRIDE__
                return this.addAddress(model)
                    .then(() => this.creating.address = false)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Customer/InformationsContentTab.vue